import { render, staticRenderFns } from "./side-drawer.vue?vue&type=template&id=1439a8cc&scoped=true"
import script from "./side-drawer.vue?vue&type=script&lang=js"
export * from "./side-drawer.vue?vue&type=script&lang=js"
import style0 from "./side-drawer.vue?vue&type=style&index=0&id=1439a8cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1439a8cc",
  null
  
)

export default component.exports